<template>
  <v-table
    ref="table"
    name="bol"
    :items="items"
    :row-height="50"
    :coreColumnDefs="coreColumnDefs"
    :defaultSort="{ prop: 'pickup_date', order: 'descending' }"
    :getHeight="getHeight"
    @loadMore="$emit('loadMore')"
  >
  </v-table>
</template>
<script>
import Vue from "vue";

Vue.component("bol-id", {
  props: { item: Object, options: Object },
  template: `
    <div :class="{wiggle: item.new}">
      <popup componentPath="components/html" width="900px" :pivot-y="0" :resizable="false" :options="{ url: '/bols/' + item.id }">
        {{item.id}}
      </popup>
    </div>
  `,
});

Vue.component("bol-priority", {
  props: { item: Object, options: Object },
  template: `
    <container-priority :item="{ id: item.id, priority: item.priority }" :key="prefixKey('priority', item.id)"/>
  `,
});

Vue.component("bol-new-trip", {
  props: { item: Object, options: Object },
  template: `
    <popover componentPath="pages/bols/trip" placement="bottom" :options="{id: item.id}">
      <el-button size="mini" type="primary" plain>New</el-button>
    </popover>
  `,
});

import api from "@/default/utils/api";
export default {
  name: "BolTable",
  mixins: [api],
  props: {
    items: {
      type: Array,
      required: true,
    },
    origin: {
      type: Boolean,
      default: true,
    },
    start: {
      type: Boolean,
      default: true,
    },
    loadTrip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coreColumnDefs: [
        {
          name: "ID",
          field: "id",
          width: 60,
          component: "bol-id",
        },
        {
          name: "Hub",
          field: "hub.name",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Customer",
          field: "customer.name",
          width: 180,
          component: "v-table-column",
        },
        {
          name: "Refer. No.",
          field: "reference_no",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Bill",
          field: "billing_type",
          width: 60,
          classes: "upcase",
          component: "v-table-column",
        },
        {
          name: "Pickup",
          field: "pickup_date",
          type: "Date",
          width: 80,
          component: "v-table-column",
        },
        {
          name: "Due",
          field: "due_date",
          type: "Date",
          width: 80,
          component: "v-table-column",
        },
        {
          name: "Status",
          field: "status",
          width: 80,
          classes: "capitalize",
          component: "v-table-column",
        },
        {
          name: "PRI",
          field: "priority.value",
          width: 50,
          component: "bol-priority",
        },
        {
          name: "Trip",
          width: 100,
          component: "bol-new-trip",
        },
        {
          name: "Origin",
          field: "origin.name",
          width: 200,
          component: "v-table-column",
        },
        {
          name: "ORI. Street",
          field: "origin.street",
          width: 200,
          component: "v-table-column",
        },
        {
          name: "ORI. City",
          field: "origin.city",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "ORI. ST",
          field: "origin.state",
          width: 80,
          component: "v-table-column",
        },
        {
          name: "Start",
          field: "start.name",
          width: 150,
          component: "v-table-column",
        },
        {
          name: "Start Street",
          field: "start.street",
          width: 150,
          component: "v-table-column",
        },
        {
          name: "Start City",
          field: "start.city",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Start ST",
          field: "start.state",
          width: 80,
          component: "v-table-column",
        },
        {
          name: "Destination",
          field: "destination.name",
          width: 180,
          component: "v-table-column",
        },
        {
          name: "DEST. Street",
          field: "destination.street",
          width: 160,
          component: "v-table-column",
        },
        {
          name: "DEST. City",
          field: "destination.city",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "DEST. ST",
          field: "destination.state",
          width: 80,
          component: "v-table-column",
        },
      ],
    };
  },
  mounted() {
    const skips = [];
    if (!this.origin)
      skips.push("Origin", "ORI. Street", "ORI. City", "ORI. ST");
    if (!this.start)
      skips.push("Start", "Start Street", "Start City", "Start ST");
    if (!this.loadTrip) skips.push("Trip");
    this.coreColumnDefs = this.coreColumnDefs.filter(
      (defs) => !skips.includes(defs.name)
    );
  },
  methods: {
    getHeight() {
      return document.querySelector("#app > .content").offsetHeight - 135;
    },
    scrollTop() {
      this.$refs.table.$refs.utable.pagingScrollTopLeft(0, 0);
    },
  },
};
</script>
